import addressModule from '@/store/modules/address';
import actions from '@/store/modules/shippingLabelPage/actions';
import getters from '@/store/modules/shippingLabelPage/getters';
import mutations from '@/store/modules/shippingLabelPage/mutations';

function state() {
  return {
    loading: true,
  };
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
  modules: {
    shipTo: addressModule,
    shipFrom: addressModule,
  },
};
